module.exports = __webpack_public_path__ + "img/ssb_menu14.11cbdf86.png";